export default "__VITE_ASSET__cf2a8164__"